import socketIO from "socket.io-client";

const options = {
    path: "/notification",
    transports: ["polling", "websocket"],
    reconnectionDelay: 1000,
    reconnectionDelayMax: 30000,
    autoConnect: false,
};

let user = wv.participantData;

if (user && user.authToken) {
    options.query = `authToken=${user.authToken}&meetingID=${getMeetingIdFromURL()}`;
}

const socketIOInstance = socketIO.connect(getAPIUrl(), options);

socketIOInstance.on(error => {
    console.log('SocketIO client Error', error.message);
});

export default socketIOInstance;
